/* eslint-disable */

import React, { useEffect, useState, useRef } from 'react';
import SiderComponent from './../components/SiderComponent';
import HeaderComponent from './../components/HeaderComponent';
import EditCoursesComponent from './../components/EditCoursesComponent';
import TitlePicturePlaceholder from './../assets/TitlePicturePlaceholder.jpg';
import config from '../config';
import { useSelector, useDispatch } from 'react-redux';
import { setGolfClubDetails } from '../redux/actions/golfClubActions';

import {
  Layout,
  Form,
  Input,
  Button,
  Row,
  Col,
  InputNumber,
  Select,
  Checkbox,
  Upload,
  Alert,
  notification,
  Switch,
} from 'antd';
import {
  UploadOutlined,
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  LinkOutlined,
  EditOutlined,
} from '@ant-design/icons';
import greenfeeDealsApi from '../api/greenfeeDeals';
import {
  BtnFilefold,
  EditPenIcon,
  LinkGreenIcon,
  LocationIconGreen,
  MailGreenIcon,
  PhoneGreenIcon,
  UploadArrow,
  WebGreenIcon,
} from '../assets/icons/icons';

const { Content } = Layout;

function Details(props) {
  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = {
    headers: { Authorization: `Bearer ${sessionBnd}` },
  };
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { Option } = Select;
  const golfClubDetails = useSelector(
    (state) => state.golfClub.golfClubDetails,
  );
  const userDetails = useSelector((state) => state.general.userDetails);
  const userRole = userDetails.role;
  const alliances = useSelector((state) => state.general.alliances);
  let alliancesIds = [];
  let AllianceValues = [];
  const [isEditingContact, setIsEditingContact] = useState(false);

  const [inputKey, setInputKey] = useState(0);
  const courseRefs = useRef([]);
  const formatEuro = (value) => {
    if (value === null || value === undefined || value === '') return '';

    const cleaned = String(value).replace(/[ €]/g, '').replace(',', '.');
    if (isNaN(Number(cleaned))) return value + ' ';

    const num = Number(cleaned);
    const rounded = Math.round((num + Number.EPSILON) * 100) / 100;

    let formatted = rounded.toFixed(2).replace('.', ',');

    if (formatted.endsWith(',00')) {
      formatted = formatted.replace(',00', '');
    }

    return `${formatted} €`;
  };

  const roundValue = (raw) => {
    if (raw === null || raw === undefined || raw === '') return '';

    const cleaned = String(raw).replace(/[ €]/g, '').replace(',', '.');
    if (cleaned === '' || isNaN(Number(cleaned))) return '';

    const parsed = Number(cleaned);
    return Math.round((parsed + Number.EPSILON) * 100) / 100;
  };

  const deepSetField = (obj, path, value) => {
    if (!obj) obj = {};
    const temp = { ...obj };
    let current = temp;

    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];

      if (current[key] === undefined) {
        current[key] = Number.isInteger(path[i + 1]) ? [] : {};
      }

      current[key] = Array.isArray(current[key])
        ? [...current[key]]
        : { ...current[key] };

      current = current[key];
    }

    current[path[path.length - 1]] = value;
    return temp;
  };

  const EuroInput = ({ form, namePath, style = {}, placeholder = '€' }) => {
    const [isTyping, setIsTyping] = useState(false);
    const [inputKey, setInputKey] = useState(0);

    return (
      <div style={{ marginBottom: 0, position: 'relative' }}>
        <Form.Item name={namePath} style={{ marginBottom: 0, width: '100%' }}>
          <InputNumber
            key={inputKey}
            size="large"
            step={0.01}
            placeholder={placeholder}
            style={{ width: '100%', ...style }}
            parser={(v) => {
              if (!v) return '';
              return String(v).replace(/[ €]/g, '').replace(',', '.');
            }}
            formatter={(v) => {
              if (v === null || v === undefined || v === '') return '';
              const cleaned = String(v).replace(/[ €]/g, '').replace(',', '.');
              const num = Number(cleaned);
              if (isNaN(num) || num === 0) return '';
              if (isTyping) return String(v);
              return formatEuro(String(v));
            }}
            onFocus={() => setIsTyping(true)}
            onBlur={(e) => {
              setIsTyping(false);
              const rounded = roundValue(e.target.value);

              form.setFieldsValue({
                [namePath[0]]: deepSetField(
                  form.getFieldValue(namePath[0]),
                  namePath.slice(1),
                  rounded === '' ? undefined : rounded,
                ),
              });

              setInputKey((k) => k + 1);
            }}
          />
        </Form.Item>
        {/* <span
          style={{ position: 'absolute', left: 50, top: 7, color: '#628478' }}
        >
          €
        </span> */}
      </div>
    );
  };

  // Reusable checkbox row — uses shouldUpdate (NO name prop) so it
  // re-renders on form state changes and stays visible
  const ServiceCheckbox = ({ fieldPath, label }) => (
    <Form.Item shouldUpdate style={{ marginBottom: 14 }}>
      {() => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: 14 }}>{label}</span>
          <Checkbox
            checked={!!form.getFieldValue(fieldPath)}
            onChange={(e) => {
              const services =
                form.getFieldValue(['golfClubValues', 'services']) || {};
              form.setFieldsValue({
                golfClubValues: {
                  ...form.getFieldValue('golfClubValues'),
                  services: {
                    ...services,
                    [fieldPath[fieldPath.length - 1]]: e.target.checked,
                  },
                },
              });
            }}
          />
        </div>
      )}
    </Form.Item>
  );

  alliances.forEach((e) => {
    alliancesIds.push(e._id);
  });

  alliancesIds.forEach((e) => {
    if (golfClubDetails.alliances && golfClubDetails.alliances.includes(e)) {
      AllianceValues.push(true);
    } else {
      AllianceValues.push(false);
    }
  });

  if (!golfClubDetails) {
    props.history.push(`/`);
    return <div></div>;
  }

  const updateGolfClub = async (values) => {
    if (!values.golfClubValues) {
      values.golfClubValues = {};
    }

    // getFieldsValue(true) captures ALL values including those set
    // manually via setFieldsValue (e.g. checkboxes with no name prop)
    const allValues = form.getFieldsValue(true);

    const payload = {
      ...values.golfClubValues,
      services: {
        ...values.golfClubValues?.services,
        ...allValues?.golfClubValues?.services,
      },
    };
    console.log('----', payload);
    await greenfeeDealsApi.patch(`/golfclubs/${golfClubId}`, payload, headers);

    const golfClub = await greenfeeDealsApi.post(
      `/golfclubs/golfClubAdmin`,
      { id: golfClubId },
      headers,
    );
    if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
      console.log('Error no Golfclub found for your Admin Account');
      return;
    }
    const results = golfClub.data.data.data;

    dispatch(setGolfClubDetails(results));

    notification.success({
      message: 'Update Successfully',
      description: 'The golf club details have been updated successfully.',
    });
    setIsEditingContact(false);
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const uploadImageData = new FormData();
    uploadImageData.append('imageCover', file);
    try {
      const golfClubImage = await greenfeeDealsApi.patch(
        `/golfclubs/${golfClubId}`,
        uploadImageData,
        headers,
      );
      const golfClub = await greenfeeDealsApi.post(
        `/golfclubs/golfClubAdmin`,
        { id: golfClubId },
        headers,
      );
      if (golfClub.data.status !== 'success' || golfClub.data.results === 0) {
        console.log('Error no Golfclub found for your Admin Account');
        return;
      }
      const results = golfClub.data.data.data;

      dispatch(setGolfClubDetails(results));
    } catch (err) {
      console.log('Eroor: ', err);
      const error = new Error('Some error');
      onError({ err });
    }
  };

  useEffect(() => {
    if (!golfClubDetails) return;
    console.log('--247---', golfClubDetails);
    form.setFieldsValue({
      golfClubValues: {
        ...golfClubDetails,
        rentals: cleanedRentals,
        services: {
          startTimeReservation:
            !!golfClubDetails?.services?.startTimeReservation,
          proShop: !!golfClubDetails?.services?.proShop,
          restaurant: !!golfClubDetails?.services?.restaurant,
          guestLockers: !!golfClubDetails?.services?.guestLockers,
          dogsOk: !!golfClubDetails?.services?.dogsOk,
          edsRound: golfClubDetails?.services?.edsRound,
          birdieBook: golfClubDetails?.services?.birdieBook,
          birdieBookUrl: golfClubDetails?.services?.birdieBookUrl,
        },
      },
    });
  }, [golfClubDetails]);

  const golfClubId = golfClubDetails._id.golfClub;

  // const cleanedRentals = {
  //   ...golfClubDetails?.rentals,
  //   eCart:
  //     golfClubDetails?.rentals?.eCart === 3
  //       ? 3
  //       : golfClubDetails?.rentals?.eCart,
  //   eTrolley:
  //     golfClubDetails?.rentals?.eTrolley === 3
  //       ? 3
  //       : golfClubDetails?.rentals?.eTrolley,
  //   trolley:
  //     golfClubDetails?.rentals?.trolley === 3
  //       ? 3
  //       : golfClubDetails?.rentals?.trolley,
  // };
  const cleanedRentals = {
    eCart: golfClubDetails?.rentals?.eCart ?? null,
    eTrolley: golfClubDetails?.rentals?.eTrolley ?? null,
    trolley: golfClubDetails?.rentals?.trolley ?? null,
    semiSet: golfClubDetails?.rentals?.semiSet ?? null,
  };
  const increaseBalls = () => {
    const current =
      form.getFieldValue(['golfClubValues', 'drivingrange', 'balls']) || 0;

    form.setFieldsValue({
      golfClubValues: {
        ...form.getFieldValue('golfClubValues'),
        drivingrange: {
          ...form.getFieldValue(['golfClubValues', 'drivingrange']),
          balls: Number(current) + 1,
        },
      },
    });
  };

  const decreaseBalls = () => {
    const current =
      form.getFieldValue(['golfClubValues', 'drivingrange', 'balls']) || 0;

    if (current <= 0) return;

    form.setFieldsValue({
      golfClubValues: {
        ...form.getFieldValue('golfClubValues'),
        drivingrange: {
          ...form.getFieldValue(['golfClubValues', 'drivingrange']),
          balls: Number(current) - 1,
        },
      },
    });
  };

  return (
    <div className="form-layout-style">
      <Layout style={{ minHeight: '100vh' }}>
        <SiderComponent props={props} />
        <Layout>
          <HeaderComponent />
          <Content
            style={{
              backgroundColor: '#F5F5F5',
              paddingLeft: 50,
              paddingRight: 50,
              paddingBottom: 50,
            }}
          >
            <Form
              key={golfClubDetails?._id?.golfClub}
              form={form}
              onFinish={updateGolfClub}
              hideRequiredMark
              initialValues={{
                golfClubValues: {
                  ...golfClubDetails,
                  rentals: cleanedRentals,
                },
                AllianceValues: AllianceValues,
              }}
              layout="vertical"
              className="inside-container"
            >
              {/* Kontaktdaten Section */}
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: 16,
                  width: '100%',
                  padding: '32px 40px',
                  marginTop: 30,
                  marginInline: 'auto',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 32,
                  }}
                >
                  <h2 className="Form-heading">Kontaktdaten</h2>

                  <div style={{ display: 'flex', gap: 12 }}>
                    {!isEditingContact ? (
                      <Button
                        className="btn-style-common"
                        onClick={() => setIsEditingContact(true)}
                      >
                        Edit
                      </Button>
                    ) : (
                      <>
                        <Button
                          onClick={() => setIsEditingContact(false)}
                          style={{ borderRadius: 10 }}
                        >
                          Cancel
                        </Button>

                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{
                            backgroundColor: '#1B392F',
                            borderColor: '#1F4D3D',
                            borderRadius: 10,
                          }}
                        >
                          Speichern
                        </Button>
                      </>
                    )}
                  </div>
                </div>
                <fieldset
                  disabled={!isEditingContact}
                  style={{ border: 'none', padding: 0 }}
                >
                  <Row gutter={24}>
                    {/* Left Column - Image Upload */}
                    <Col span={10}>
                      <div style={{ marginBottom: 12 }}>
                        <div className="label-style">Bild des Clubs</div>
                      </div>
                      <div
                        style={{
                          border: '1.5px dashed #00000010',
                          borderRadius: 15,
                          padding: 32,
                          textAlign: 'center',
                          backgroundColor: '#EDF2F030',
                          minHeight: 220,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <Upload
                          name="avatar"
                          showUploadList={false}
                          customRequest={uploadImage}
                        >
                          {golfClubDetails.imageCover ? (
                            <img
                              src={`https://greenfeedeals2.s3.eu-central-1.amazonaws.com/${golfClubDetails.imageCover}`}
                              alt="avatar"
                              style={{
                                width: '100%',
                                cursor: 'pointer',
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <>
                              <UploadArrow />
                              <div
                                style={{
                                  color: '#222222',
                                  fontSize: 14,
                                  marginBlock: 4,
                                  fontWeight: 500,
                                }}
                              >
                                Drop image here
                              </div>
                              <div style={{ color: '#8C8C8C', fontSize: 12 }}>
                                1485x683px, max 1MB
                              </div>
                            </>
                          )}
                        </Upload>
                      </div>
                    </Col>

                    <Col span={14}>
                      <Row gutter={18}>
                        <Col span={18}>
                          <Form.Item
                            label="Clubname"
                            name={['golfClubValues', 'name']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="Great Admin Club"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={6}>
                          <Form.Item
                            label="DGV-Nr"
                            name={['golfClubValues', 'dgvNumber']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="Clubnummer"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={18} style={{ marginTop: 20 }}>
                        <Col span={12} className="column-style-cls">
                          <Form.Item
                            label={
                              <div className="label-icon-clsn">
                                <LocationIconGreen />
                                Straße & Hausnummer
                              </div>
                            }
                            name={['golfClubValues', 'address', 'street']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="Enter address"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>

                          <Form.Item
                            label={
                              <div className="label-icon-clsn">
                                <PhoneGreenIcon />
                                Telefon
                              </div>
                            }
                            name={['golfClubValues', 'phone']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="+43 142 254578"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>

                          <Form.Item
                            label={
                              <div className="label-icon-clsn">
                                <WebGreenIcon />
                                Website
                              </div>
                            }
                            name={['golfClubValues', 'url']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="https://www.clud.de"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="column-style-cls">
                          <Row gutter={12}>
                            <Col span={10}>
                              <Form.Item
                                label="PLZ"
                                name={['golfClubValues', 'address', 'zip']}
                                className="inputbox-clsn"
                              >
                                <Input
                                  size="large"
                                  placeholder="12345"
                                  style={{ borderRadius: 10 }}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={14}>
                              <Form.Item
                                label="Ort"
                                name={['golfClubValues', 'address', 'city']}
                                className="inputbox-clsn"
                              >
                                <Input
                                  size="large"
                                  placeholder="City"
                                  style={{ borderRadius: 10 }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Form.Item
                            label={
                              <div className="label-icon-clsn">
                                <MailGreenIcon />
                                Email
                              </div>
                            }
                            name={['golfClubValues', 'email']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="info@club.de"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>

                          <Form.Item
                            label={
                              <div className="label-icon-clsn">
                                <LinkGreenIcon />
                                Booking URL
                              </div>
                            }
                            name={['golfClubValues', 'startTimeBookingUrl']}
                            className="inputbox-clsn"
                          >
                            <Input
                              size="large"
                              placeholder="https://booking.club.de"
                              style={{ borderRadius: 10 }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </fieldset>
              </div>

              {/* Plätze und Greenfee Section */}
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: 16,
                  width: '100%',
                  padding: '32px 40px',
                  marginTop: 24,
                }}
              >
                <div>
                  <h2 className="Form-heading">Plätze und Greenfee</h2>
                  <p
                    style={{
                      color: '#ff0404',
                      margin: '8px 0 0 0',
                      fontSize: 14,
                      fontWeight: 500,
                      lineHeight: '1.5',
                    }}
                  >
                    Greenfee für Gäste mit goldenem Hologramm/ DGV "R" während
                    der Hauptsaison. Abweichende Preise bitte unter "Specials"
                    oder "VcG & Fernmitglieder" definieren.
                  </p>
                </div>
                {golfClubDetails.courses.map((item, index) => {
                  const isLast = index === golfClubDetails.courses.length - 1;
                  return (
                    <EditCoursesComponent
                      ref={(el) => (courseRefs.current[index] = el)}
                      course={item}
                      key={item[0]._id}
                      isLast={isLast}
                    />
                  );
                })}
              </div>

              {/* Bottom Section - Three Columns */}
              <Row
                gutter={20}
                style={{ marginTop: 24 }}
                className="dropdown-style-change"
              >
                {/* Driving Range */}
                <Col span={8}>
                  <div
                    style={{
                      backgroundColor: 'white',
                      borderRadius: 16,
                      padding: '28px 32px',
                      height: '100%',
                    }}
                    className="column-style-cls"
                  >
                    <h3 className="Form-heading">Driving Range</h3>
                    <Form.Item
                      label="Abschlagplätze"
                      name={['golfClubValues', 'drivingrange', 'ranges']}
                      style={{ marginBottom: 18 }}
                    >
                      <Select
                        size="large"
                        placeholder="Mats"
                        style={{ borderRadius: 10 }}
                      >
                        <Option value="Rasen">Rasen</Option>
                        <Option value="Matten">Matten</Option>
                        <Option value="Rasen & Matten">Rasen & Matten</Option>
                        <Option value="keine">keine</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Überdachung"
                      name={['golfClubValues', 'drivingrange', 'covered']}
                      style={{ marginBottom: 18 }}
                    >
                      <Select
                        size="large"
                        placeholder="Partially"
                        style={{ borderRadius: 10 }}
                      >
                        <Option value="ja">ja</Option>
                        <Option value="teilweise">teilweise</Option>
                        <Option value="nein">nein</Option>
                      </Select>
                    </Form.Item>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span style={{ fontSize: 14 }}>Pitch-/ Chip-Area</span>
                      <Form.Item
                        name={['golfClubValues', 'drivingrange', 'pitchAreas']}
                        valuePropName="checked"
                        style={{ marginBottom: 0 }}
                      >
                        <Switch />
                      </Form.Item>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <span style={{ fontSize: 14 }}>Putting Green</span>
                      <Form.Item
                        name={[
                          'golfClubValues',
                          'drivingrange',
                          'puttingGreen',
                        ]}
                        valuePropName="checked"
                        style={{ marginBottom: 0 }}
                      >
                        <Switch />
                      </Form.Item>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={{
                          color: '#262626',
                          fontWeight: 500,
                          fontSize: 14,
                        }}
                      >
                        Anzahl Bälle je Token
                      </div>
                      <div className="counterbutton">
                        <Button
                          size="small"
                          style={{ borderRadius: 0, border: 0 }}
                          onClick={decreaseBalls}
                        >
                          -
                        </Button>
                        <Form.Item
                          name={['golfClubValues', 'drivingrange', 'balls']}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            size="small"
                            style={{
                              padding: 0,
                              textAlign: 'center',
                              borderRadius: 10,
                              border: 0,
                              marginBottom: 0,
                              backgroundColor: 'transparent',
                            }}
                          />
                        </Form.Item>
                        <Button
                          size="small"
                          style={{ borderRadius: 0, border: 0 }}
                          onClick={increaseBalls}
                        >
                          +
                        </Button>
                      </div>
                    </div>
                    <Form.Item
                      label="Kosten Token"
                      style={{ marginBottom: 18 }}
                    >
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'drivingrange', 'token']}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>
                    <Form.Item label="Rangefee" style={{ marginBottom: 0 }}>
                      <EuroInput
                        form={form}
                        namePath={[
                          'golfClubValues',
                          'drivingrange',
                          'rangefee',
                        ]}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>
                  </div>
                </Col>

                {/* Verleih */}
                <Col span={8}>
                  <div
                    style={{
                      backgroundColor: 'white',
                      borderRadius: 16,
                      padding: '28px 32px',
                      height: '100%',
                    }}
                    className="column-style-cls input-price-align"
                  >
                    <h3 className="Form-heading">Verleih (Gäste, 18-Loch)</h3>

                    <Form.Item
                      className="ant-left-price"
                      label="E-Cart"
                      style={{ marginBottom: 18 }}
                    >
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'rentals', 'eCart']}
                        style={{ borderRadius: 10, width: '50%' }}
                      />
                    </Form.Item>

                    <Form.Item
                      className="ant-left-price"
                      label="E-Trolley"
                      style={{ marginBottom: 18 }}
                    >
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'rentals', 'eTrolley']}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>

                    <Form.Item
                      className="ant-left-price"
                      label="Trolley"
                      style={{ marginBottom: 18 }}
                    >
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'rentals', 'trolley']}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>

                    <Form.Item
                      className="ant-left-price"
                      label="Leihschläger"
                      style={{ marginBottom: 0 }}
                    >
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'rentals', 'semiSet']}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>
                  </div>
                </Col>

                {/* Services */}
                <Col span={8}>
                  <div
                    style={{
                      backgroundColor: 'white',
                      borderRadius: 16,
                      padding: '28px 32px',
                      height: '100%',
                    }}
                    className="column-style-cls"
                  >
                    <h3 className="Form-heading">Services</h3>

                    {/* 
                      KEY FIX: Use shouldUpdate WITHOUT name prop.
                      - shouldUpdate makes it re-render when form state changes (needed for checked state)
                      - No name prop prevents the conflict that hides the checkbox
                      - Checkbox values are captured on save via form.getFieldsValue(true)
                    */}
                    <ServiceCheckbox
                      fieldPath={[
                        'golfClubValues',
                        'services',
                        'startTimeReservation',
                      ]}
                      label="Startzeitenreservierung erforderlich"
                    />

                    <ServiceCheckbox
                      fieldPath={['golfClubValues', 'services', 'proShop']}
                      label="Pro Shop"
                    />

                    <ServiceCheckbox
                      fieldPath={['golfClubValues', 'services', 'restaurant']}
                      label="Gastronomie"
                    />

                    <ServiceCheckbox
                      fieldPath={['golfClubValues', 'services', 'guestLockers']}
                      label="Gästesanitär"
                    />

                    <ServiceCheckbox
                      fieldPath={['golfClubValues', 'services', 'dogsOk']}
                      label="Hunde erlaubt"
                    />

                    <Form.Item label="RPR-Runde" style={{ marginBottom: 18 }}>
                      <EuroInput
                        form={form}
                        namePath={['golfClubValues', 'services', 'edsRound']}
                        placeholder="€"
                        style={{ borderRadius: 10 }}
                      />
                    </Form.Item>

                    <div
                      style={{
                        backgroundColor: '#F4F8F7',
                        borderRadius: 8,
                        padding: '12px',
                        border: '1px solid #00000010',
                      }}
                      className="birdiebook-deals"
                    >
                      <h4
                        style={{
                          fontSize: 15,
                          fontWeight: 600,
                          marginBottom: 16,
                          color: '#1F1F1F',
                        }}
                      >
                        Birdiebook
                      </h4>

                      <Form.Item
                        label="Preis für haptisches Birdiebook"
                        style={{ marginBottom: 16 }}
                      >
                        <EuroInput
                          form={form}
                          namePath={[
                            'golfClubValues',
                            'services',
                            'birdieBook',
                          ]}
                          placeholder="€"
                          style={{ borderRadius: 10 }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Link zum digitalen Birdiebook"
                        name={['golfClubValues', 'services', 'birdieBookUrl']}
                        rules={[
                          {
                            pattern:
                              /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}.*$/,
                            message: 'Please enter a valid URL',
                          },
                        ]}
                        style={{ marginBottom: 0 }}
                      >
                        <Input
                          size="large"
                          placeholder="Enter URL"
                          style={{ borderRadius: 10 }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Paket-Limits — nur GFD-Admin */}
              {userRole === 'admin' && (
                <Row gutter={[16, 16]} style={{ marginTop: 32 }}>
                  <Col span={24}>
                    <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: '20px 24px' }}>
                      <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 4, color: '#1B392F' }}>Paket-Limits</h3>
                      <p style={{ fontSize: 13, color: '#8c8c8c', marginBottom: 16 }}>Nur für GFD-Admins sichtbar</p>
                      <Row gutter={[24, 0]}>
                        <Col span={8}>
                          <label style={{ fontSize: 13, color: '#595959', fontWeight: 500, display: 'block', marginBottom: 4 }}>
                            Top-Platzierungen (gleichzeitig aktiv)
                          </label>
                          <Form.Item name={['golfClubValues', 'package', 'featuredDealsLimit']} style={{ marginBottom: 0 }}>
                            <InputNumber min={0} max={20} style={{ width: '100%', height: 40 }} placeholder="0" />
                          </Form.Item>
                        </Col>
                        <Col span={8}>
                          <label style={{ fontSize: 13, color: '#595959', fontWeight: 500, display: 'block', marginBottom: 4 }}>
                            Push-Benachrichtigungen (pro Monat)
                          </label>
                          <Form.Item name={['golfClubValues', 'package', 'pushNotificationsLimit']} style={{ marginBottom: 0 }}>
                            <InputNumber min={0} max={100} style={{ width: '100%', height: 40 }} placeholder="0" />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              )}

              {/* Save Button */}
              {(userRole === 'admin' || userRole === 'golfClubAdmin') && (
                <Row justify="end" style={{ marginTop: 24, marginBottom: 30 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{
                      backgroundColor: '#1B392F',
                      borderColor: '#1F4D3D',
                      minWidth: 140,
                      height: 44,
                      fontSize: 15,
                      fontWeight: 500,
                      borderRadius: 10,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 8,
                    }}
                  >
                    <BtnFilefold />
                    Speichern
                  </Button>
                </Row>
              )}
            </Form>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default Details;
